<template>
  <v-alert
    colored-border
    :color="cardStyle.color"
    :icon="cardStyle.icon"
    border="top"
    elevation="2"
    prominent
  >
    <v-row v-if="loading" justify="center">
      <v-progress-circular indeterminate width="2" />
    </v-row>
    <div v-else>
      <div class="subheading grey--text text--darken-2">
        Latest Run:
        {{ overdue ? 'Overdue' : status.status || 'None' }}
      </div>
      <div class="headline">{{ status.start | date }}</div>
    </div>
  </v-alert>
</template>

<script>
import { cardStyle } from '../lib/colors';
import moment from 'moment';

export default {
  props: {
    status: { type: Object },
    loading: { type: Boolean },
  },
  computed: {
    cardStyle() {
      return cardStyle(
        this.loading,
        !this.overdue,
        !(this.status && this.status.start),
      );
    },
    overdue() {
      const momentStart = this.status ? moment(this.status.start) : null;

      return (
        moment().diff(momentStart, 'minutes') > this.$store.state.scheduleDelay
      );
    },
  },
};
</script>
